// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getSurveys as listSurveysAPI,
    getSurvey as getSurveyAPI,
    addSurvey as addSurveyAPI,
    duplicateSurvey as duplicateSurveyAPI,
    updateSurvey as updateSurveyAPI,
    deleteSurvey as deleteSurveyAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { surveysApiResponseError, surveysApiResponseSuccess } from './actions';
import { SurveysActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getSurvey({ payload: { id } }) {
    try {
        const response = yield call(getSurveyAPI, id );
        const surveyItem = response.data.data;
        yield put(surveysApiResponseSuccess(SurveysActionTypes.GET_SURVEY, surveyItem));
    } catch (error) {
        yield put(surveysApiResponseError(SurveysActionTypes.GET_SURVEY, error));
    }
}

function* addSurvey({payload:survey}){
    try{
        const response = yield call(addSurveyAPI,{...survey})
        const surveyItem = response.data
        yield put(surveysApiResponseSuccess(SurveysActionTypes.ADD_SURVEY,surveyItem))
    } catch(error){
        yield put(surveysApiResponseError(SurveysActionTypes.ADD_SURVEY,error))
    }
}

function* duplicateSurvey({payload:survey}){
    try{
        const response = yield call(duplicateSurveyAPI,{...survey})
        const surveyItem = response.data
        yield put(surveysApiResponseSuccess(SurveysActionTypes.DUPLICATE_SURVEY,surveyItem))
    } catch(error){
        yield put(surveysApiResponseError(SurveysActionTypes.DUPLICATE_SURVEY,error))
    }
}

function* updateSurvey({payload:survey}){
    try{
        const response = yield call(updateSurveyAPI,{...survey})
        const surveyItem = response.data.data
        yield put(surveysApiResponseSuccess(SurveysActionTypes.UPDATE_SURVEY,surveyItem))
    }catch(error){
        yield put(surveysApiResponseError(SurveysActionTypes.UPDATE_SURVEY,error))
    }
}
function* deleteSurvey({payload:{id}}){
    try{
        const response = yield call(deleteSurveyAPI,id)
        const surveyItem = response.data.id
        yield put(surveysApiResponseSuccess(SurveysActionTypes.DELETE_SURVEY,surveyItem))
    }catch(error){
        yield put(surveysApiResponseError(SurveysActionTypes.DELETE_SURVEY,error))
    }
}

/**
 * List contactos
 */
function* listSurveys({payload:params}) {
    try {
        const response = yield call(listSurveysAPI, { ...params });
        const listaSurveys = response.data.data;
        yield put(surveysApiResponseSuccess(SurveysActionTypes.LIST_SURVEYS, listaSurveys));
    } catch (error) {
        yield put(surveysApiResponseError(SurveysActionTypes.LIST_SURVEYS, error));
    }
}


export function* watchGetSurvey(): any {
    yield takeEvery(SurveysActionTypes.GET_SURVEY, getSurvey);
}

export function* watchListSurveys(): any {
    yield takeEvery(SurveysActionTypes.LIST_SURVEYS, listSurveys);
}

export function* watchAddSurvey():any{
    yield takeEvery(SurveysActionTypes.ADD_SURVEY,addSurvey)
}

export function* watchDuplicateSurvey():any{
    yield takeEvery(SurveysActionTypes.DUPLICATE_SURVEY,duplicateSurvey)
}

export function* watchUpdateSurvey():any{
    yield takeEvery(SurveysActionTypes.UPDATE_SURVEY,updateSurvey)
}
export function* watchDeleteSurvey():any{
    yield takeEvery(SurveysActionTypes.DELETE_SURVEY,deleteSurvey)
}


function* surveysSaga(): any {
    yield all([
        fork(watchGetSurvey),
        fork(watchListSurveys),
        fork(watchAddSurvey),
        fork(watchDuplicateSurvey),
        fork(watchUpdateSurvey),
        fork(watchDeleteSurvey),
    ]);
}

export default surveysSaga;
